import { Dispatch } from 'redux'

import { SingleTagProps, Tag } from '../Types'
import { handleAddNewTag, removeTag, updateTagsImmediate } from './Helper'
import {
  newContributionTags,
  updateContributionTags,
} from 'redux/thunks/TextAnalysis'
import { setContributionTags, updateAllTags } from 'redux/slices/TextAnalysis'
import { TAResponseProps } from 'types/TextAnalysis'

export const handleDeleteTag = (
  dispatch: Dispatch<any>,
  item: TAResponseProps,
  index: number,
  tagToRemove: SingleTagProps,
  type: string,
) => {
  const obj = {
    id: item.id,
    source_id: item.attributes.source_id,
    tags: removeTag(index, tagToRemove),
  }
  dispatch(setContributionTags({ index, newTags: obj.tags }))
  if (type === 'contributionTags') {
    dispatch(updateContributionTags(obj))
  }
}

export const onAddNewTagHandler = async (
  dispatch: Dispatch<any>,
  item: TAResponseProps,
  index: number,
  tagToAdd: (string | Tag)[],
  type: string,
  showAlert: (arg: {
    type: 'error' | 'success' | 'info'
    title: string
  }) => void,
) => {
  let newTags = null

  const handleNewTag = async () => {
    const payload = handleAddNewTag(item, tagToAdd)
    const result = await dispatch(newContributionTags(payload))

    if (result?.type.includes('fulfilled') && result?.payload?.tags) {
      dispatch(updateAllTags(result?.payload?.tags[0]))
      return updateTagsImmediate(index, result?.payload?.tags[0])
    } else if (result?.type.includes('rejected')) {
      showAlert({
        type: 'error',
        title: result?.payload,
      })
      return null
    }
  }

  const handleExistingTag = () => {
    return updateTagsImmediate(index, tagToAdd)
  }

  if (type === 'new') {
    newTags = await handleNewTag()
  } else if (type === 'existing') {
    newTags = handleExistingTag()
  }

  if (newTags) {
    dispatch(setContributionTags({ index, newTags }))
  }
}
